import moment from 'moment'
import createPaginationModule from '../generic/pagination'
import createSingleItemCrudModule from '../generic/single-item-crud'
import { putSmsNotificationMarkAsReadApi } from './logistics-apis'
import { createNotificationSmsSearchInputs, createNotificationSmsSuggestions } from './search-inputs'
import { RETRIEVE } from '@/constants/store-actions'
import { formatTwilioError } from '@/utils/twilio-status'
import { SUPER_MANAGER, SUPER_MANAGER_READ_ONLY } from '@/constants/permissions'
import { hasCommonElement } from '@/utils/helper_functions'

const endpoint = '/user_api/v1/sms_notifications'
const url = (
  process.env.VUE_APP_USER_API_ENDPOINT +
  endpoint
)

function canFilterTwilioData (rootState) {
  return hasCommonElement(rootState.profile.permissions || [], [SUPER_MANAGER, SUPER_MANAGER_READ_ONLY])
}

function parseSMSItems (item) {
  return {
    id: item.id,
    user_email: item.user_email,
    phone_number: item.phone_number,
    plant: item.plant,
    planner_group: item.planner_group,
    storage_location: item.storage_location,
    work_center: item.work_center,
    message: item.message,
    created: moment(item.created).format('lll'),
    // Twilio delivery tracking (KPT-1036). Only present for super_manager /
    // super_manager_read_only; the API omits these fields for other roles.
    twilio_sid: item.twilio_sid,
    twilio_status: item.twilio_status,
    twilio_error_code: item.twilio_error_code,
    twilio_error_message: item.twilio_error_message,
    twilio_delivery_error: formatTwilioError(item.twilio_error_code, item.twilio_error_message),
    segments: item.segments,
    price: item.price,
    price_unit: item.price_unit,
    sent_at: item.sent_at ? moment(item.sent_at).format('lll') : null,
    delivered_at: item.delivered_at ? moment(item.delivered_at).format('lll') : null,
    status_updated: item.status_updated ? moment(item.status_updated).format('lll') : null
  }
}

export default {
  namespaced: true,
  modules: {
    smsPagination: createPaginationModule(
      {
        endpoint: url,
        mapper: parseSMSItems
      }),
    smsCrud: createSingleItemCrudModule(
      {
        endpoint: url,
        actions: [RETRIEVE]
      })
  },
  state: {
  },
  getters: {
    // KPT-1117: the SMS Status / Error Code filters are only offered to the
    // roles that can see the Twilio columns. Deciding it here keeps the
    // suggestion list and the allowed inputs in sync - a suggestion the input
    // set rejects would render as a red tag. profile.permissions is absent
    // until the profile is fetched, hence the fallback.
    searchSuggestionsList (state, getters, rootState) {
      return createNotificationSmsSuggestions(canFilterTwilioData(rootState))
    },
    allowedSearchInputs (state, getters, rootState) {
      return createNotificationSmsSearchInputs(canFilterTwilioData(rootState))
    }
  },
  actions: {
    async markAsRead ({ commit }, id) {
      const requestPromise = putSmsNotificationMarkAsReadApi(id)
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.error({ _: 'Mark SMS Notification As Read failed', error })
        })
      return requestPromise
    }
  }
}
